document.addEventListener('theme:cart:open', initCartBundleItems);

if (document.querySelector('[data-cart-page]')) {
  document.addEventListener('DOMContentLoaded', initCartBundleItems);
}

function initCartBundleItems() {
	const cartBundleItems = document.querySelectorAll('.boa-cart-bundle-items');
	if (!cartBundleItems) {
		return;
	}
	cartBundleItems.forEach((cartBundle) => {
		const itemComponents = cartBundle.querySelector('.bundle-items-components');
		const showItemsButton = cartBundle.querySelector('.show-bundle-items-button');
		const toggleIcon = showItemsButton.querySelector('.cart-bundle-toggle-icon');
		const buttonText = showItemsButton.querySelector('.cart-bundle-button-text');

		showItemsButton.addEventListener('click', () => {
			const isHidden = itemComponents.classList.toggle('hidden-bundle-items');
			toggleIcon.classList.toggle('rotate-svg', !isHidden);
			buttonText.textContent = isHidden
				? itemComponents.dataset.showItems
				: itemComponents.dataset.hideItems;
		});
	});
}
